import { NativeInfoCmd, VJSBridge } from '@/libs/VJSBridge';
import { VJSBridgeFront } from '@/libs/VJSBridgeFront';
import { AccountInfo, ChannelInfo, UserInfo, InviteInfo, DeleteAccountPreventItem } from '@/types/account';
import { EntityDataWrapper, ListDataWrapper } from '@/types/request';
import { devAutoExecuteWrapper, requestILink, timeoutPromiseWrapper } from '@/utils/request';
import {
  VALIDATE_INVITE_CODE,
  GET_SELF_ACCOUNT,
  APPLY_ACCOUNT,
  APPLY_DELETE_ACCOUNT,
  CANCEL_DELETE_ACCOUNT,
  BIND_BANK_ACCOUNT,
  BIND_CHANNEL_INFO,
  GET_USER_INFO,
  GET_INVITE_INFO,
} from './cmd';
/*
 * @Description: 用户账户相关的接口
 * @Author: erickuang
 * @Date: 2021-08-16 20:28:52
 * @LastEditor: erickuang
 * @LastEditTime: 2021-08-24 20:24:57
 */
export const validateInviteCode = ({ code = '' }: Partial<
{ code: string }
> = {}) => requestILink<EntityDataWrapper<{unionID: string}>>({ cmd: VALIDATE_INVITE_CODE, code });

export const getAccountInfo = () => requestILink<AccountInfo>({ cmd: GET_SELF_ACCOUNT });

export const applyAccount = ({
  citizenNo = '',
  phone = '',
  name = '',
}: Partial<{
  citizenNo: string;
  phone: string;
  name: string
}>) => requestILink<AccountInfo>({ cmd: APPLY_ACCOUNT, citizenNo, phone, name });

export const applyDeleteAccount = () => requestILink<ListDataWrapper<DeleteAccountPreventItem>>({
  cmd: APPLY_DELETE_ACCOUNT,
});

export const cancelDeleteAccount = () => requestILink<{}>({
  cmd: CANCEL_DELETE_ACCOUNT,
});

export const cancelAccountApplication = () => requestILink<AccountInfo>({ cmd: GET_SELF_ACCOUNT });
export const bindBankAccount =
  ({
    name = '',
    phoneNum = '',
    citizenNo = '',
    bank = '',
    province = '',
    city = '',
    account = '',
  }: Partial<{
    name: string;
    citizenNo: string;
    phoneNum: string;
    bank: string;
    province: string;
    city: string;
    account: string;
  }>) => requestILink<AccountInfo>({
    cmd: BIND_BANK_ACCOUNT,
    name,
    phoneNum,
    citizenNo,
    bank,
    province,
    city,
    account,
  });

export const bindChannelId = ({
  finderUsername = '',
  nickname = '',
  headImgURL = '',
  inviter = '',
}: Partial<ChannelInfo>) => requestILink({
  cmd: BIND_CHANNEL_INFO,
  finderUsername,
  nickname,
  headImgURL,
  inviter,
});

export const getUserChannelData = () => devAutoExecuteWrapper<ChannelInfo>(
  NativeInfoCmd.GetUserChannelData,
  timeoutPromiseWrapper((res) => {
    VJSBridge.getVJSBridge().sendGetNativeInfoOperation(
      {
        cmd: NativeInfoCmd.GetUserChannelData,
      },
      (data: ChannelInfo) => {
        res(data);
      },
    );
  }, { cmd: NativeInfoCmd.GetUserChannelData }),
  {
    callbackId: VJSBridgeFront.getCallbackId() - 1,
  },
);

export const getUserInfo = () => requestILink<UserInfo>({ cmd: GET_USER_INFO });

export const getInviteInfo = ({
  start = 0,
  length = 10,
}: {
  start: number;
  length: number;
}) => requestILink<EntityDataWrapper<InviteInfo>>({ cmd: GET_INVITE_INFO, start, length });
